var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-1"},[_c('div',{staticClass:"line-row",style:({
      background: _vm.item.event.color,
      height: '5px',
      position: 'relative'
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }